import { useEffect, useMemo, useState } from "react";
import Loader from "./Loader";
import { pdfS3URL } from "../config";
import ImgPanelClose from "../assets/panel-close.png";
import ImgPanelOpen from "../assets/panel-open.png";

const PdfVIew = ({ productId, collapsed, onCollapseClick }) => {
  const [pdfNotfound, setPDFNotfound] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const pdfURL = useMemo(() => {
    if (productId) {
      return `${pdfS3URL}${productId}&navpanes=0&toolbar=0&statusbar=0&view=FitH`;
    }
    return pdfS3URL;
  }, [productId]);

  const checkPDFExists = async () => {
    setIsLoading(true);
    try {
      const response = await fetch(pdfURL, {
        method: "GET",
      });
      if (
        !response.ok ||
        !response.headers.get("Content-Type").includes("application/pdf")
      ) {
        setPDFNotfound(true);
      }
    } catch (error) {
      console.error("An error occurred:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (!productId) return;
    checkPDFExists();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [productId]);

  return (
    <div
      className={`h-100 d-flex flex-column ${collapsed ? "pdf-collapsed" : ""}`}
    >
      {/* HEADER */}
      <div
        className={`section-header d-flex justify-content-between align-items-center border-bottom ${
          collapsed ? "px-2 py-2" : "px-3 py-2"
        }`}
        style={{ borderRadius: collapsed ? "12px" : "" }}
      >
        <h4
          className="mb-0"
          style={{
            display: collapsed ? "none" : "block",
          }}
        >
          Source Material
        </h4>

        <button
          className="btn btn-sm"
          onClick={onCollapseClick}
          title={!collapsed ? "Minimize" : "Maximize"}
        >
          <img
            src={!collapsed ? ImgPanelClose : ImgPanelOpen}
            alt="img-panel"
          />
        </button>
      </div>
      <div
        className="border text-center position-relative"
        style={{
          height: "calc(100vh - 88px)",
          display: collapsed ? "none" : "block",
        }}
      >
        {isLoading && <Loader />}
        {!pdfNotfound ? (
          <iframe
            id="pdf"
            title="pdf"
            src={pdfURL}
            height="100%"
            width="100%"
            navpanes="1"
          />
        ) : (
          <div>PDF NOT FOUND</div>
        )}
      </div>
    </div>
  );
};

export default PdfVIew;
